// Shared configuration constants
export const REACT_APP_DOCS_URL = process.env.REACT_APP_DOCS_URL || 'https://docs.sophare.ai';
export const REACT_APP_API_GATEWAY_URL_CONTACT =
  'https://7h3bxirxu7.execute-api.us-east-2.amazonaws.com/Production/signup';
// harmless localhost key for default value
export const REACT_APP_TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '0x4AAAAAAB-5p-3xXwTj_Pt5';
